import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  label: {
    marginBottom: theme.spacing()
  }
}));

export default function KjosandiInfo(props) {
  const classes = useStyles();
  const { kjosandi, fjoldiAtkvaeda } = props;

  return (
    <div>
      <Paper className={classes.paper}>
        <Grid container spacing={2} direction="row" alignItems="center">
          <Grid item xs>
            <InputLabel className={classes.label}>
              Fullt nafn kjósanda
            </InputLabel>
            <Typography>{kjosandi.nafn}</Typography>
          </Grid>
          <Grid item xs>
            <InputLabel className={classes.label}>Lögheimili</InputLabel>
            <Typography>{kjosandi.husheiti}</Typography>
          </Grid>
          <Grid item xs>
            <InputLabel className={classes.label}>Sveitarfélag</InputLabel>
            <Typography>{kjosandi.sveitarfelag}</Typography>
          </Grid>
          <Grid item xs>
            <InputLabel className={classes.label}>Kjördæmi</InputLabel>
            <Typography>{kjosandi.kjordaemi}</Typography>
          </Grid>
          <Grid item xs={3}>
            <InputLabel className={classes.label}>
              Kjörstaður / Kjördeild
            </InputLabel>
            <Typography>
              {kjosandi.kjorstadurNumer}.{kjosandi.kjordeild} (
              {kjosandi.kjorstadur})
            </Typography>
          </Grid>
          {fjoldiAtkvaeda > 0 && (
            <Grid item xs={1}>
              <Tooltip
                title={`Kjósandi hefur skilað ${fjoldiAtkvaeda} atkvæðum`}
              >
                <Badge color="primary" badgeContent={fjoldiAtkvaeda}>
                  <MailOutlinedIcon fontSize="large" color="action" />
                </Badge>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Paper>
    </div>
  );
}